import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { AirplaySecurityProfileEffects } from './airplay-security-profile.effects';
import { airplaySecurityProfilesReducer } from './airplay-security-profile.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('airplaySecurityProfiles', airplaySecurityProfilesReducer),
    EffectsModule.forFeature([AirplaySecurityProfileEffects]),
  ],
  providers: [],
})
export class AirplaySecurityProfilestoreModule {}
